import { mdiBellOutline, mdiChartBoxOutline, mdiCommentAlertOutline, mdiHandshakeOutline, mdiHome, mdiMessage, mdiNewspaperVariantMultipleOutline, mdiPackageVariantClosed, mdiTicketPercent, mdiViewListOutline, mdiWarehouse, mdiStorefrontOutline } from '@mdi/js'

// Array of sections

export default [
	{
		icon: mdiHome,
		title: 'Dashboard',
		to: 'shop-dashboard',
	},
	{
		title: 'categories',
		icon: mdiViewListOutline,
		module: 'MGS,categories',
		children: [
			{
				title: 'categories',
				to: 'shop-categories-list',
			},
			{
				title: 'subCategories',
				to: 'shop-subcategories-list',
			},
		],
	},
	{
		icon: mdiWarehouse,
		title: 'menu.shop.productSuppliers',
		to: 'shop-product-suppliers-list',
		module: 'MGS,product-suppliers',
	},
	{
		icon: mdiHandshakeOutline,
		title: 'menu.shop.deals',
		to: 'shop-deals',
		module: 'MGS,deals',
	},
	{
		icon: mdiChartBoxOutline,
		title: 'menu.shop.dealsDashboard',
		to: 'shop-deals-dashboard',
		module: 'MGS,deals',
	},
	{
		icon: mdiCommentAlertOutline,
		title: 'menu.shop.dealCommunity',
		to: 'shop-deals-community',
		module: 'MGS,deals',
	},
	{
		icon: mdiTicketPercent,
		title: 'menu.shop.coupons',
		to: 'shop-coupons-list',
		module: 'MGS,product-suppliers',
	},
	{
		icon: mdiStorefrontOutline,
		title: 'menu.shop.stores',
		to: 'shop-retailers-list',
		module: 'MGS,product-suppliers',
	},
	{
		icon: mdiPackageVariantClosed,
		title: 'menu.shop.products',
		to: 'shop-products-list',
		module: 'MGS,product-suppliers',
	},
	{
		icon: mdiMessage,
		title: 'menu.messages',
		to: 'shop-messages-list',
		module: 'MGS,messages',
	},
	{
		icon: mdiNewspaperVariantMultipleOutline,
		title: 'Newsletter',
		to: 'shop-newsletter-list',
		module: 'MGS,newsletter',
	},
	{
		icon: mdiBellOutline,
		title: 'notifications.notifications',
		module: 'MGS,notifications',
		children: [
			{
				title: 'menu.notifications.list',
				to: 'shop-notifications-list',
			},
			{
				title: 'menu.notifications.templates',
				to: 'network-notification-templates-list',
			},
		],
	},
]
